export default "__VITE_ASSET__DP9$5SsP__"